import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [
  LIST_CHANCE_ESTIMATE,
  LIST_CHANCE_ESTIMATE_SUCCESS,
  LIST_CHANCE_ESTIMATE_FAILURE,
] = createRequestActionTypes('chance/LIST_CHANCE_ESTIMATE');

export const listChanceEstimates = createAction(
  LIST_CHANCE_ESTIMATE,
  (id) => id,
);
const listChanceEstimatesSaga = createRequestSaga(
  LIST_CHANCE_ESTIMATE,
  chanceApi.getEstimates,
);

const UNLOAD_ESTIMATE = 'chance/UNLOAD_ESTIMATE';
export const unloadEstimates = createAction(UNLOAD_ESTIMATE);

export function* chanceEstimatesSaga() {
  yield takeLatest(LIST_CHANCE_ESTIMATE, listChanceEstimatesSaga);
}

const initialState = {
  estimates: null,
  error: null,
};

const chanceEstimates = handleActions(
  {
    [LIST_CHANCE_ESTIMATE_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      estimates: data.list.map((estimate) => ({
        id: estimate.qteUuid,
        qteUuid: estimate.qteUuid,
        prjUuid: estimate.prjUuid,
        qteTyp: estimate.qteTyp, //견적서 종류
        qteKind: estimate.qteKind,
        qteKindNm: estimate.qteKindNm,
        qteNo: estimate.qteNo, //견적서 번호
        partnerUuid: estimate.partnerUuid,
        partnerNm: estimate.partnerNm,
        qteRegDt: estimate.qteRegDt, //견적일자
        qteValidDt: estimate.qteValidDt, //유효견적일자
        destPlace: estimate.destPlace, //납품장소
        payCond: estimate.payCond, //결제조건
        mntTor: estimate.mntTor, //유지보수기간
        qtePrice: estimate.qtePrice, //총 견적금액
        qteCondt: estimate.qteCondt, //발행조건
        qteUsrNm: estimate.qteUsrNm,
        qteUsrTel: estimate.qteUsrTel,
        qteUsrEml: estimate.qteUsrEml,
        qteDesc1: estimate.qteDesc1,
        qteDesc2: estimate.qteDesc2,
        qteDesc3: estimate.qteDesc3,
        useYn: estimate.useYn,
        crtUsr: estimate.crtUsr,
        crtNm: estimate.crtNm,
        crtDt: estimate.crtDt,
        cngUsr: estimate.cngUsr,
        cngNm: estimate.cngNm,
        cngDt: estimate.cngDt,
      })),
      error: null,
    }),
    [LIST_CHANCE_ESTIMATE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_ESTIMATE]: () => initialState,
  },
  initialState,
);

export default chanceEstimates;
